import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=68d31957&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"
import style0 from "./tree.vue?vue&type=style&index=0&id=68d31957&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d31957",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealerDownload: require('/root/workspace/web-company_Yo6Q/components/dealer/popup/dealerDownload.vue').default})
